import { NgModule } from '@angular/core';
import { CynoDateParserFormatter } from '@app/shared/cyno-form/datepicker-popup/cyno-date-parser-formatter';
import { DateNativeAdapter } from '@app/shared/cyno-form/datepicker-popup/date-native.adapter';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [],
    exports: [
        NgbDatepickerModule,
    ],
    providers: [
        { provide: NgbDateAdapter, useClass: DateNativeAdapter },
        { provide: NgbDateParserFormatter, useClass: CynoDateParserFormatter },
    ],
})
export class NgBootstrapModule {}
